/**
 * Registre des articles SATELLITES qui densifient chaque dossier ETM.
 *
 * Chaque dossier-pilier (route, circulation, conducteur, ...) est complété
 * par 8 articles "satellites" plus courts, focalisés sur un angle précis.
 *
 * STATUTS :
 *   - 'published'   : article rédigé, contenu complet en `body`
 *   - 'coming-soon' : titre + teaser + estimation publication
 *
 * Total cible (Vague 1) : 72 articles (8 × 9 dossiers)
 * Rédigés (Vague 1)     : 9 flagship (1 par dossier) — qualité magazine
 * Vague 2 (à venir)     : 63 articles restants, par lots de 8 prioritaires
 *
 * Structure article satellite :
 *   {
 *     slug, parentSlug, title, kicker, teaser, body[],
 *     readTimeMin, status, publishedAt?, authorNote?
 *   }
 *
 *   body[] = liste de blocks { type, ...props } :
 *     - 'paragraph'   { text }
 *     - 'subtitle'    { text }
 *     - 'callout'     { tone:'info'|'warning'|'tip'|'mistake', title, text }
 *     - 'keypoints'   { title, items[] }
 *     - 'quote'       { text, source }
 *     - 'sources'     { items[{label, url?}] }
 */

import { routeSatellites } from './route';
import { circulationSatellites } from './circulation';
import { conducteurSatellites } from './conducteur';
import { autresUsagersSatellites } from './autres-usagers';
import { notionsDiversesSatellites } from './notions-diverses';
import { mecaniqueSatellites } from './mecanique';
import { epiSatellites } from './epi';
import { environnementSatellites } from './environnement';
import { premiersSecoursSatellites } from './premiers-secours';

export const SATELLITES_BY_PARENT = {
  route: routeSatellites,
  circulation: circulationSatellites,
  conducteur: conducteurSatellites,
  'autres-usagers': autresUsagersSatellites,
  'notions-diverses': notionsDiversesSatellites,
  mecanique: mecaniqueSatellites,
  epi: epiSatellites,
  environnement: environnementSatellites,
  'premiers-secours': premiersSecoursSatellites,
};

// Index plat : { slug: article }
export const SATELLITES_INDEX = Object.values(SATELLITES_BY_PARENT)
  .flat()
  .reduce((acc, art) => {
    acc[art.slug] = art;
    return acc;
  }, {});

export function getSatellitesByParent(parentSlug) {
  return SATELLITES_BY_PARENT[parentSlug] || [];
}

export function getPublishedSatellitesByParent(parentSlug) {
  return (SATELLITES_BY_PARENT[parentSlug] || []).filter(
    (a) => a.status === 'published',
  );
}

export function getSatelliteBySlug(slug) {
  return SATELLITES_INDEX[slug] || null;
}

export function getSatelliteStats() {
  const all = Object.values(SATELLITES_BY_PARENT).flat();
  return {
    total: all.length,
    published: all.filter((a) => a.status === 'published').length,
    drafting: all.filter((a) => a.status === 'coming-soon').length,
  };
}
